import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';

function RedirectPropertyTypesLegacy() {
  const [search] = useSearchParams();
  const q = search.toString();
  return <Navigate to={q ? `/reference-data?${q}` : '/reference-data'} replace />;
}
import { useAuth } from './auth/AuthContext';
import { Loading } from './ui/kit';
import { Layout } from './components/Layout';
import { tr } from './lib/i18n';
import { DashboardPage } from './pages/DashboardPage';
import { FormBuilderPage } from './pages/form-builder/FormBuilderPage';
import { FormPreviewPage } from './pages/form-builder/FormPreviewPage';
import { FormsListPage } from './pages/form-builder/FormsListPage';
import { LoginPage } from './pages/LoginPage';
import { OrganizationDetailsPage } from './pages/OrganizationDetailsPage';
import { OrganizationsPage } from './pages/OrganizationsPage';
import { PlansPage } from './pages/PlansPage';
import { ProfilePage } from './pages/ProfilePage';
import { PropertiesOverviewPage } from './pages/PropertiesOverviewPage';
import { ReferenceDataPage } from './pages/ReferenceDataPage';
import { RequestsOverviewPage } from './pages/RequestsOverviewPage';

export function App() {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === 'loading') return <Loading h={window.innerHeight} />;
  if (status === 'anonymous') {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace state={{ from: loc.pathname }} />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/organizations/:id" element={<OrganizationDetailsPage />} />
        <Route path="/reference-data" element={<ReferenceDataPage />} />
        <Route path="/property-types" element={<RedirectPropertyTypesLegacy />} />
        <Route path="/categories" element={<Navigate to="/reference-data?tab=categories" replace />} />
        <Route path="/features" element={<Navigate to="/reference-data?tab=features" replace />} />
        <Route path="/locations" element={<Navigate to="/reference-data?tab=locations" replace />} />
        <Route path="/forms" element={<FormsListPage />} />
        <Route path="/forms/:id" element={<FormBuilderPage />} />
        <Route path="/forms/:id/preview" element={<FormPreviewPage />} />
        <Route path="/overview/properties" element={<PropertiesOverviewPage />} />
        <Route path="/overview/requests" element={<RequestsOverviewPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
